import { Injectable } from '@angular/core';
import { HttpService } from './http-service.service';
import { environment } from '../../environments/environment'; 
import { Observable,firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})


export class AuthService {
  isLoggedIn = false;
  userId: any;
  userData: any;
  validUser = false;
  constructor(private httpService: HttpService, private http: HttpClient, private router: Router,) {
  }


  setUserData(data: any): any {
    this.userData = data;
  }

  getUserData(): any {
    return this.userData;
  }

  setUserId(userId: any) {
    this.userId = userId;
  }

  getUserID() {
    return this.userId;
  }

  getUserName() {
    return this.userData.userName;
  }



}
